/*
 * @Author: LiuChuanQi
 * @Date: 2023-01-29 16:20:25
 * @LastEditTime: 2023-01-30 09:36:31
 * @LastEditors: LiuChuanQi
 * @Description: 全局提示框注册文件
 * @FilePath: \speedtest-bigdata-v2\src\components\common\message\messageBox.js
 * 
 */
import msgboxVue from './messageBox.vue';    
// 定义插件对象
const MessageBox = {};
// vue的install方法，用于定义vue插件
MessageBox.install = function (Vue, options) {
  //Vue.extend Vue构造器 ，创建一个子类，参数是一个包含组件选项的对象
  const MessageBoxInstance = Vue.extend(msgboxVue);
  let currentMsg;
  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new MessageBoxInstance();
    /**
     * currentMsg.$mount()是将currentMsg实例对象的render模板渲染到文档外，返回值还是obj实例对象
     * $el指的是render函数中模板dom节点
     */
    let msgBoxEl = currentMsg.$mount().$el; 
    document.body.appendChild(msgBoxEl);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$msgBox = {
    showMsgBox (options) {
      if (!currentMsg) {
        //没有弹窗就初始化弹窗dom
        initInstance();
      }
      if (typeof options === 'string') {
        //如果传入字符串代表传入的内容是弹窗的内容、而非配置项
        currentMsg.content = options;
      } else if (typeof options === 'object') {
        console.log(currentMsg);
        Object.assign(currentMsg, options);
      }
//  Object.assign方法只会拷贝源对象自身的并且可枚举的属性到目标对象
      return currentMsg.showMsgBox()
        .then(val => {
          currentMsg = null;
          return Promise.resolve(val);
        })
        .catch(err => {
          currentMsg = null;
          return Promise.reject(err);
        });
    }
  };
};
export default MessageBox;

